module.exports = __webpack_public_path__ + "img/bag_2.1b3fbc79.svg";